module.exports = __webpack_public_path__ + "static/img/3.63d9650.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/3.png
// module id = Fw9o
// module chunks = 0